/**
 * Base public search DTO
 */
export abstract class BasePublicSearchDto {
  id!: number;
  color?: string | null;
}
